export default __webpack_public_path__ + "static/media/dip_phone_hands.39dc2ff4.png";